import { PageComponent } from "barba"

class ScrollHeight {
    constructor({ node }) {
        this.node = node
        this.raf = null
        this.updateHandler = this.update.bind(this)
        this.updateRafHandler = this.updateRaf.bind(this)
        window.addEventListener("resize", this.updateHandler)
        this.update();
    }

    update() {
        this.raf = window.requestAnimationFrame(this.updateRafHandler)
    }

    updateRaf() {
        if (this.node && this.node.style) {
            this.node.style.setProperty('--scroll-height', `${this.node.scrollHeight}px`);
        }
    }

    destroy() {
        window.removeEventListener("resize", this.updateHandler)

        if (this.raf) {
            window.cancelAnimationFrame(this.raf)
        }

        delete this.node
        delete this.raf
        delete this.updateHandler
        delete this.updateRafHandler
    }
}

new PageComponent("[data-scroll-height]", ScrollHeight)
